import React, { useEffect } from 'react';
import MfaEnrollment from './MfaEnrollment';

const MfaEnrollmentModal = ({ isOpen, user, onSuccess, onClose }) => {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black/50 backdrop-blur-sm overflow-y-auto">
      <div 
        className="relative w-full max-w-md my-4" 
        onClick={(e) => e.stopPropagation()}
      >
        <MfaEnrollment 
          user={user} 
          onSuccess={onSuccess} 
          onCancel={onClose} 
        />
      </div>
    </div>
  );
};

export default MfaEnrollmentModal; 